import { getBlockGap, getBlockGapX, getPaddingX, getPaddingY } from '$lib/global/helper/layout';

import type { Box as BoxType } from '$lib/types/Components/SharedTypes';
import type { BrandSpacing, Theme } from '$lib/types/Theme';

export interface ResolvedListStyling {
    blockGapXClass: string | undefined;
    blockGapYClass: string | undefined;
    paddingXClass: string | undefined;
    paddingYClass: string | undefined;
    boxWithPaddingStripped: BoxType | undefined;
}

interface Params {
    theme: Theme | undefined;
    box: BoxType | undefined;
}

// Theming 2.0 only — per-block style overrides are not supported.
export const resolveListStyling = ({ theme, box }: Params): ResolvedListStyling => {
    const blockGapXClass = theme?.blockGap
        ? getBlockGapX(theme.blockGap as BrandSpacing)
        : undefined;
    const blockGapYClass = theme?.blockGap
        ? getBlockGap(theme.blockGap as BrandSpacing)
        : undefined;

    const paddingXClass = theme?.paddingX ? getPaddingX(theme.paddingX as BrandSpacing) : undefined;
    const paddingYClass = theme?.paddingY ? getPaddingY(theme.paddingY as BrandSpacing) : undefined;

    // When brand paddings are set, move the padding off the outer Box and onto
    // the inner div — matches React's behaviour in List/Component.tsx.
    const hasBrandPadding = !!(paddingXClass || paddingYClass);
    const boxWithPaddingStripped: BoxType | undefined =
        hasBrandPadding && box
            ? {
                  ...box,
                  top: paddingYClass ? 'none' : box.top,
                  bottom: paddingYClass ? 'none' : box.bottom,
                  left: paddingXClass ? 'none' : box.left,
                  right: paddingXClass ? 'none' : box.right,
              }
            : box;

    return {
        blockGapXClass,
        blockGapYClass,
        paddingXClass,
        paddingYClass,
        boxWithPaddingStripped,
    };
};
